export const ADDON_CATEGORY_LOCAL_PRESENCE = 1;
export const ADDON_CATEGORY_GENERAL = 2;